<template>
    <div class="container flex-wrap flex-line">
      <div style="flex-shrink:0;width:140px;height:100%;border-right:1px solid var(--border);overflow-y:auto;"
      >

         <BaseMenu
            :menus="menus"
            :actived="actived"
            @on-click="handleOpen"
        >
        </BaseMenu>
      </div>
      <div style="width:calc(100% - 140px);height:100%;position:relative;">

          <router-view></router-view>
      </div>
    </div>
  </template>

<script>
import {mapGetters} from 'vuex';
import responsableMixin from '@/mixins/responsable';
export default {
  routerOption: {
    as_default: true,
    as_frame: true,
  },
  mixins: [responsableMixin],
  mounted() {

  },
  computed: {
    ...mapGetters('cm', ['permission']),
    sm() {
      return this.w < 1200;
    },
    menus() {
      const items = [
        {
          name: '投标情况',
          key: 'info',
          icon: 'md-speedometer',
        },
        {
          name: '投标工作',
          key: 'work',
          icon: 'table',
        },
      ];
      return items;
    },
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },

  }, methods: {
    handleOpen(e) {
      this.RouteTo(e);
      localStorage.setItem('cm-route-key', e);
    },
  },
};
</script>

